 
// @ts-nocheck
// Disabled because of flare-space-menu

import styles from "./Header.module.scss";
import logo from "../../../../assets/flare_space-lr.svg";
import NetworkToggle from "@components/NetworkToggle/NetworkToggle.component";
import TimeZoneSelect from "../TimeZoneSelect/TimeZoneSelect";
import { Group } from "@mantine/core";

const Header: React.FC = () => {
  return (
    <div className={styles.header}>
      <div className={styles.background}></div>
      <nav>
        <a href={"https://flare.space/"}>
          <img className={styles.logo} src={logo} alt="flare-space" />
        </a>
        <aside className={styles.menuWrapper}>
          <flare-space-menu>
          </flare-space-menu>
        </aside>
      </nav>
    </div>
  );
};

export default Header;
